/** Temporary flush diagnostics — remove after manual QA. */
export const inviteFlushDebug = (tag: string, data: Record<string, unknown>): void => {
  console.warn(`[${tag}]`, JSON.stringify(data));
};
